import { FunctionComponent } from "react";

import "./LinkButton.css";
import { ButtonHTMLType } from "antd/es/button";

interface LinkButtonProps {
  iconPrefix?: React.ReactNode;
  iconSuffix?: React.ReactNode;
  children: React.ReactNode;
  onPress: (event: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel?: string;
  disabled?: boolean;
  role?: string;
  type?: "destructive" | "default" | "info";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  color?: string;
  /**
   * Set the original html type of button, @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#type
   * @default "button"
   */
  htmlType?: ButtonHTMLType;
}

const LinkButton: FunctionComponent<LinkButtonProps> = ({
  iconPrefix,
  iconSuffix,
  children,
  onPress,
  ariaLabel,
  disabled = false,
  role = "button",
  type = "default",
  size = "medium",
  fullWidth = false,
  htmlType = "button",
  color,
}) => {
  return (
    <button
      className={`link-button-component ${type} ${size} ${
        fullWidth ? "full-width" : ""
      }`}
      style={{ color }}
      onClick={onPress}
      aria-label={ariaLabel}
      disabled={disabled}
      role={role}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === "Space") {
          e.preventDefault();
          onPress(e as unknown as React.MouseEvent<HTMLButtonElement>);
        }
      }}
      tabIndex={disabled ? -1 : 0}
      type={htmlType}>
      {iconPrefix && (
        <span className="icon-prefix" aria-hidden="true">
          {iconPrefix}
        </span>
      )}
      {children}
      {iconSuffix && (
        <span className="icon-suffix" aria-hidden="true">
          {iconSuffix}
        </span>
      )}
    </button>
  );
};

export { LinkButton };
